module.exports = __webpack_public_path__ + "static/media/icon-open-account.bed7e499.svg";